import { CatalogMetadataValue, CatalogMetadataType } from '../../gql-operations/gql-generated';
import { Skill, SkillType } from '../types';
import { translateTextualEntity } from './i18n/translateTextualEntity';

export const mapSkills = (rawValues: CatalogMetadataValue[]): Skill[] =>
    rawValues.map((rawValue) => ({
        id: rawValue.id,
        name: translateTextualEntity(rawValue.name),
        iconUrl: rawValue.iconUrl || undefined,
        type: mapSkillType(rawValue.type),
    }));

const mapSkillType = (rawValue: CatalogMetadataType): SkillType => ({
    id: rawValue.id,
    name: translateTextualEntity(rawValue.name),
});
